function e(e){return`[${e.slice(2)}]`}export{e as encodeLabelhash};
